import { useTranslation } from 'react-i18next';
import Loader from "../../UI/Loader";
import {CleanUrl} from "../../../utils/cleanUrl";

const ModalError = (props) => {
    const { backToStart, formSubmitInProgress, errorMessageCode, errorMessageHeadline, errorMessageText } = props;
    const { t } = useTranslation();
    const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);

    return (
        <>
            <div className="pweu-modal-overlay">
                <div className="pweu-modal">
                    {errorMessageCode === "continue_stop" ? (
                        <div className="pweu-close-modal">
                            <a href={window.promotionHome}>
                                <img src={imagePath + "delete--white.svg"} alt="" />
                            </a>
                        </div>
                    ) : (
                        <div className="pweu-close-modal" onClick={backToStart}>
                            <img src={imagePath + "delete--white.svg"} alt="" />
                        </div>
                    )}
                    <div className="pweu-modal-content">
                        <div className="pweu-confirmation-feedback">
                            <img src={imagePath + "not-completed.svg"} alt="" />
                            {errorMessageCode !== "continue_try_again" ?
                                <>
                                    <h2>{errorMessageHeadline}</h2>
                                    <p>{errorMessageText}</p>
                                </> :
                                <>
                                    <h2>{t("The participation could not be completed")}</h2>
                                    <p>{t("Try again in a while")}</p>
                                </>}

                            <div className="btn-wrapper">
                                {errorMessageCode === "continue_stop" ? (
                                    <a href={window.promotionHome} className="btn btn-primary-text">{t("Back to Start")}</a>
                                ) : (errorMessageCode === "continue_adjust" ? (
                                    <input type="button" onClick={backToStart} className="btn btn-primary-text" value={t("Try again")} />
                                ) : (
                                    <>
                                        {formSubmitInProgress ? <Loader /> :
                                            <>
                                                <input type="submit" className="btn btn-primary" value={t("Try again")} />
                                                <input type="button" onClick={backToStart} className="btn btn-primary-text" value={t("Back to Start")} />
                                            </>
                                        }
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalError;
